import { c as _c } from "react/compiler-runtime";
import { fillVariants } from "../../../styles";
export const ArbitrumNovaLogoSquare = t0 => {
  const $ = _c(11);
  let className;
  let rest;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      size: t1,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = t1;
  } else {
    className = $[1];
    rest = $[2];
    t1 = $[3];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  if ($[4] !== size) {
    t2 = {
      width: size,
      height: size
    };
    $[4] = size;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <g fill="none" fillRule="evenodd"><rect fill="#2D374B" height={24} rx={0} width={24} /><path d="M9.293 6H7.674a.266.266 0 0 0-.25.175L3.168 17.822a.133.133 0 0 0 .125.178h1.62c.111 0 .21-.07.25-.175L9.417 6.178A.133.133 0 0 0 9.293 6Zm1.97 4.88a.133.133 0 0 0-.25 0l-.84 2.298a.265.265 0 0 0 0 .182l1.632 4.465a.266.266 0 0 0 .25.175h1.62a.133.133 0 0 0 .125-.178l-2.537-6.942Zm4.128 2.249a.133.133 0 0 0 .25 0l2.54-6.95A.133.133 0 0 0 18.056 6h-1.62a.266.266 0 0 0-.25.175l-1.635 4.474a.265.265 0 0 0 0 .182l.84 2.298Zm-3.193-6.956A.264.264 0 0 0 11.95 6h-1.625a.266.266 0 0 0-.25.175L5.82 17.822a.133.133 0 0 0 .125.178h1.62c.111 0 .211-.07.25-.175l3.258-8.917a.067.067 0 0 1 .126 0l3.259 8.917a.266.266 0 0 0 .25.175h1.619a.133.133 0 0 0 .125-.178L12.198 6.173ZM20.708 6h-1.62a.266.266 0 0 0-.25.175l-2.961 8.102a.265.265 0 0 0 0 .182l.84 2.298a.133.133 0 0 0 .25 0l2.93-8.021.935-2.558A.133.133 0 0 0 20.707 6Z" fill="#EF8220" fillRule="nonzero" /></g>;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== className || $[8] !== rest || $[9] !== t2) {
    t4 = <svg className={className} style={t2} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...rest}>{t3}</svg>;
    $[7] = className;
    $[8] = rest;
    $[9] = t2;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
export const ArbitrumNovaLogoSquareMonochrome = t0 => {
  const $ = _c(18);
  let className;
  let rest;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      className,
      size: t1,
      fill: t2,
      fillAttribute: t3,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    className = $[1];
    rest = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  const size = t1 === undefined ? 24 : t1;
  const fill = t2 === undefined ? "current" : t2;
  const fillAttribute = t3 === undefined ? "currentColor" : t3;
  let t4;
  if ($[6] !== size) {
    t4 = {
      width: size,
      height: size
    };
    $[6] = size;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== fill) {
    t5 = fillVariants({
      fill
    });
    $[8] = fill;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== fillAttribute || $[11] !== t5) {
    t6 = <path className={t5} d="M0 0h24v24H0V0ZM9.293 6H7.674a.266.266 0 0 0-.25.175L3.168 17.822a.133.133 0 0 0 .125.178h1.62c.111 0 .21-.07.25-.175L9.417 6.178A.133.133 0 0 0 9.293 6Zm2.657 0h-1.625a.266.266 0 0 0-.25.175L5.82 17.822a.133.133 0 0 0 .125.178h1.62c.111 0 .211-.07.25-.175l3.258-8.917a.067.067 0 0 1 .126 0l3.259 8.917a.266.266 0 0 0 .25.175h1.619a.133.133 0 0 0 .125-.178L12.198 6.173A.264.264 0 0 0 11.95 6Zm-.937 4.88-.84 2.298a.265.265 0 0 0 0 .182l1.632 4.465a.266.266 0 0 0 .25.175h1.62a.133.133 0 0 0 .125-.178l-2.537-6.942a.133.133 0 0 0-.25 0ZM20.707 6h-1.62a.266.266 0 0 0-.25.175l-2.96 8.102a.265.265 0 0 0 0 .182l.84 2.298a.133.133 0 0 0 .25 0l2.93-8.021.935-2.558A.133.133 0 0 0 20.707 6Zm-2.651 0h-1.62a.266.266 0 0 0-.25.175l-1.635 4.474a.265.265 0 0 0 0 .182l.84 2.298a.133.133 0 0 0 .25 0l2.54-6.95A.133.133 0 0 0 18.056 6Z" fill={fillAttribute} fillRule="evenodd" />;
    $[10] = fillAttribute;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== className || $[14] !== rest || $[15] !== t4 || $[16] !== t6) {
    t7 = <svg className={className} style={t4} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...rest}>{t6}</svg>;
    $[13] = className;
    $[14] = rest;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
};